import i18n from '../i18n';

const MAP_STYLE_URL = 'https://tiles.openfreemap.org/styles/liberty';

// Cache per language
const styleCache = new Map<string, any>();

function getNameField(lang: string): any {
  // OpenFreeMap/OpenStreetMap name fields:
  // name:en, name:ja, name:zh, name:ko, name:it
  // For zh-CN and zh-TW, use name:zh (OSM doesn't distinguish)
  const osmLang = lang.startsWith('zh') ? 'zh' : lang;

  return [
    'coalesce',
    ['get', `name:${osmLang}`],
    ['get', 'name:en'],  // fallback to English
    ['get', 'name'],     // fallback to local name
  ];
}

export async function getMapStyle(lang?: string): Promise<any> {
  const currentLang = lang || i18n.language || 'en';

  if (styleCache.has(currentLang)) return styleCache.get(currentLang);

  try {
    const response = await fetch(MAP_STYLE_URL);
    const style = await response.json();

    const nameField = getNameField(currentLang);

    if (style.layers) {
      for (const layer of style.layers) {
        if (!layer.layout) continue;
        const tf = layer.layout['text-field'];
        if (!tf) continue;
        const tfStr = JSON.stringify(tf);
        if (
          tfStr.includes('name') ||
          tfStr.includes('Name') ||
          tfStr.includes('{name')
        ) {
          layer.layout['text-field'] = nameField;
        }
      }
    }

    styleCache.set(currentLang, style);
    return style;
  } catch (error) {
    console.error('Failed to load map style:', error);
    return MAP_STYLE_URL;
  }
}

// Keep backward compatibility — old name redirects to new
export async function getEnglishMapStyle(): Promise<any> {
  return getMapStyle();
}

// Clear cache when language changes (called from useLanguage hook)
export function clearMapStyleCache(): void {
  styleCache.clear();
}

export const TOKYO_STATION = { lat: 35.6812, lng: 139.7671 };
export const JAPAN_CENTER = { lat: 36.2, lng: 138.2 };
